import React, { useState } from "react";
import PropTypes from "prop-types";
import ImagePreviewModal from "../ImagePreviewModal";
import { reactIcons } from "../../utils/icons";

function UploadDocument({
  upload,
  instrunctionList,
  heading,
  handleFileChange,
  name,
  id,
  value,
  handleRemoveDoc,
  preview,
  type
}) {
  const [viewImage, setViewImage] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const userDetailsHandelar = (url) => {
    setViewImage(true);
    setImageUrl(url);
  };

  return (
    <div className="">
      <p className="text-16 md:text-[16px] mb-2 text-white font-[500]  dark:text-white">
        {heading}
      </p>
      <ul className="text-primary-400 text-12 list-disc pl-8 dark:text-lightgray">
        {instrunctionList?.map((item) => {
          return (
            <li key={item.id} className="text-12 text-white md:text-12">
              {item.text}
            </li>
          );
        })}
      </ul>
      {upload && (
        <div>
          <div className="grid grid-cols-12">
            {value &&
              value?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="col-span-2 mx-2 rounded-sm h-24 w-24 mt-2 border relative border-primary-200"
                  >
                    <div onClick={() => userDetailsHandelar(item)}>
                      <img src={`${item}`} alt="img" className="w-24 h-24" />
                    </div>

                    {/* {!preview && ( */}
                    <span
                      onClick={() => handleRemoveDoc(index, name, type)}
                      className="text-[30px] bg-white rounded-full cursor-pointer text-primary-200 absolute -top-2 -left-2"
                    >
                      {reactIcons.circleclose}
                    </span>
                    {/* )} */}
                    {/* <button
                      onClick={() => setOpenModal(true)}
                      className="px-2 py-1 my-2 text-white rounded-md text-12 bg-navy-200"
                    >
                      Preview
                    </button> */}
                  </div>
                );
              })}
          </div>
          {!preview && (
            <label htmlFor={id}>
              <div className="w-full flex mt-5 mb-3 justify-center items-center h-14 rounded-10 border-[1px]  border-dotted border-primary-200 cursor-pointer">
                <span className="text-white text-24">
                  {reactIcons.camera}
                </span>
                <input
                  name={name}
                  type="file"
                  id={id}
                  className="hidden"
                  onChange={(e) => {
                    console.log("in input");
                    console.log(e);
                    if (e.target.files[0]) handleFileChange(e, type);
                  }}
                />
              </div>
            </label>
          )}
        </div>
      )}
      <ImagePreviewModal
        viewImage={viewImage}
        ClosedImageView={() => {
          setViewImage(false);
        }}
        imageUrl={imageUrl}
        setViewImage={setViewImage}
      />
    </div>
  );
}

UploadDocument.propTypes = {
  instrunctionList: PropTypes.array,
  upload: PropTypes.bool,
  heading: PropTypes.string,
  handleFileChange: PropTypes.func,
  name: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  handleRemoveDoc: PropTypes.any,
  preview: PropTypes.any,
  type: PropTypes.string
};
export default UploadDocument;
